import axios from "axios";

const getLabFirmTetkikSearch = async (baseUrl, token, labUserId, firmId, tckno) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let getResponse = null

    await axios.get(baseUrl + `/lab/` + labUserId + "/exam/" + firmId + "/request/?patienttckno=" + tckno,  config)
        .then((res) => {
            //console.log("res.data: ", res.data)
            getResponse = {
                status: res.status,
                data: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return getResponse
}

export default getLabFirmTetkikSearch;